var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPatientDisconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_6.7.2._Vista_general:_Paciente-_Redirecci\\xF3n_al_paciente_al_finalizar_la_consulta-_Desconectada_por_el_paciente",
    "data-name": "6.7.2. Vista general: Paciente- Redirecci\\xF3n al paciente al finalizar la consulta- Desconectada por el paciente",
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 129.515,
    viewBox: "0 0 144 129.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    d: "M112.912,44.2a2.4,2.4,0,0,0-2.851,3.862,18.861,18.861,0,0,1,7.213,11.108,2.4,2.4,0,0,0,2.343,1.882,2.433,2.433,0,0,0,.521-.055,2.4,2.4,0,0,0,1.824-2.861A23.666,23.666,0,0,0,112.912,44.2Z",
    transform: "translate(-4.812 -12.048)",
    fill: "#1565c0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    d: "M131.619,61.473h.24a2.4,2.4,0,0,0,2.16-2.619,33.6,33.6,0,0,0-16.837-25.922,2.4,2.4,0,0,0-2.371,4.176,28.8,28.8,0,0,1,14.432,22.218,2.4,2.4,0,0,0,2.376,2.146Z",
    transform: "translate(-4.812 -12.048)",
    fill: "#1565c0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M143.363,61.889h.077a2.4,2.4,0,0,0,2.326-2.472A42.932,42.932,0,0,0,121.43,21.94a2.4,2.4,0,1,0-2.086,4.32,38.148,38.148,0,0,1,21.621,33.3,2.4,2.4,0,0,0,2.4,2.328Z",
    transform: "translate(-4.812 -12.048)",
    fill: "#1565c0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    d: "M147.232,123.631,87.239,18.119a12,12,0,0,0-20.867,0L6.38,123.631a12,12,0,0,0,10.434,17.932h120a12,12,0,0,0,10.434-17.932Zm-4.21,9.553a7.129,7.129,0,0,1-6.212,3.579h-120a7.2,7.2,0,0,1-6.252-10.753l60-105.512a7.2,7.2,0,0,1,12.519,0l60,105.512A7.129,7.129,0,0,1,143.022,133.183Z",
    transform: "translate(-4.812 -12.048)",
    fill: "#f7b500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    d: "M76.806,38.4A11.893,11.893,0,0,0,64.961,51.347l3.79,46.9a8.1,8.1,0,0,0,16.127-.026l3.778-46.859A11.89,11.89,0,0,0,76.806,38.4Zm3.288,59.409a3.3,3.3,0,0,1-6.56.026l-3.79-46.9a7.1,7.1,0,1,1,14.135.022Z",
    transform: "translate(-4.812 -12.048)",
    fill: "#f7b500"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    d: "M76.806,110.408a9.6,9.6,0,1,0,9.6,9.6A9.6,9.6,0,0,0,76.806,110.408Zm0,14.4a4.8,4.8,0,1,1,4.8-4.8A4.8,4.8,0,0,1,76.806,124.809Z",
    transform: "translate(-4.812 -12.048)",
    fill: "#f7b500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPatientDisconnect);
export default __webpack_public_path__ + "static/media/icon-patient-disconnect.5fbb5e7dfaf5b37ac7c99b34865d5ed4.svg";
export { ForwardRef as ReactComponent };